import { useTranslation } from 'react-i18next';

import CircularChart from '@/components/charts/CircularChart';
import { useChartTheme } from '@/components/charts/theme';
import EmptyState from '@/components/molecules/EmptyState';

import BioscopeSceneLabelsLegend from './BioscopeSceneLabelsLegend';
import {
    SCENE_LABELS_CUTOUT,
    sceneLabelSlices,
    sceneLabelTooltip,
} from './bioscopeSceneLabelsChartOptions';

import styles from './BioscopeSceneLabelsChart.module.scss';

const DEFAULT_DATA_RANGE_TITLE_KEY = '2d';

interface BioscopeSceneLabelsChartProps {
    data: number[];
    colors: string[];
    labels: string[];
    relativeCounts: number[];
}

export default function BioscopeSceneLabelsChart(props: BioscopeSceneLabelsChartProps) {
    const { data, colors, labels, relativeCounts } = props;

    const { t } = useTranslation(['bioscopeStatus']);
    const theme = useChartTheme();
    const dataRangeLabel = t(`dataRangeTitle.${DEFAULT_DATA_RANGE_TITLE_KEY}`);

    if (data.length === 0) {
        return (
            <EmptyState
                title={t('sceneLabels.noSceneLabelsReceived', {
                    dataRangeLabel: dataRangeLabel,
                })}
                appearance="quiet"
            />
        );
    }

    return (
        <>
            <p>{t('sceneLabels.basedMeasurements')}</p>
            <div className={styles.chartAndLegendContainer}>
                <div className={styles.doughnutChartContainer}>
                    <CircularChart
                        kind="doughnut"
                        slices={sceneLabelSlices(data, colors, labels)}
                        cutout={SCENE_LABELS_CUTOUT}
                        tooltip={sceneLabelTooltip}
                        animateRotate
                    />
                </div>
                <BioscopeSceneLabelsLegend
                    colors={colors.map((color) => theme.color(color))}
                    labels={labels}
                    relativeCounts={relativeCounts}
                />
            </div>
        </>
    );
}
